(function($) {
    $(function() {
        $('.uhsp-colorpicker').colorPicker();
    });
})(jQuery);